export function getUtcDateWithDayAndTime(day: string, time: string): Date | null {
    const matchDate = day.split("-")

    if (matchDate.length === 0) {
        return null
    }
    const matchTime = time.split(":")

    if (matchTime.length === 0) {
        return null
    }

    const date = new Date(
        Date.UTC(parseInt(matchDate[0], 10), parseInt(matchDate[1], 10) - 1, parseInt(matchDate[2]))
    )

    date.setUTCHours(parseInt(matchTime[0], 10), parseInt(matchTime[1], 10))

    return date
}
